import { render, staticRenderFns } from "./PCLogo.vue?vue&type=template&id=99d85d8e&scoped=true&"
import script from "./PCLogo.vue?vue&type=script&lang=js&"
export * from "./PCLogo.vue?vue&type=script&lang=js&"
import style0 from "./PCLogo.vue?vue&type=style&index=0&id=99d85d8e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d85d8e",
  null
  
)

export default component.exports